import React from "react";
import { Link } from "react-router-dom";
import "./KeyCards.css";

/* ===== ICONS (DO NOT CHANGE PATHS) ===== */
import Icon1 from "./SchemeIcons/landless.png";
import Icon2 from "./SchemeIcons/meeting.png";
// import Icon3 from "./SchemeIcons/convergence.png";
import Icon4 from "./SchemeIcons/innovation.png";
import Icon5 from "./SchemeIcons/iec.png";
import Icon6 from "./SchemeIcons/meeting.png";

const KeyCards = () => {

  /* ===== HARD CODED VALUES ===== */
  const cardCounts = {
    // Landless
    yekun_bhumihin_labharthi: 100971,
    aaj_akher_jaga_uplabhd: 98029,
    urvarith_bhunihun_labharti: 2942,

    // Capacity Building
    yekun_karyashala_sankhya: 144295,
    labharthi_melave: 144295,
    prashikshan_purn_zalelya_gavandi_sankya: 7654973,

    // Convergence
    swachh_bharat: 0,
    jaljivan: 0,
    ujjwala: 0,
    saubhagya: 0,
    gramin_jivannoti: 0,
    dalit_vasti: 0,
    thakkar_bappa: 0,
    zilla_parishad: 0,
    panchayat_samiti: 0,
    grampanchayat: 0,
    csr: 0,

    // Innovation
    bahumajli_imarti: 0,
    gruhsankule: 0,
    bahumajli_gruhsankule: 0,
    crop_shop: 0,
    demo_house: 0,
    land_bank: 0,
    sand_bank: 0,
    gharkul_mart: 0,
    valula_paryay: 0,
    gruhkarj: 0,
    aadarsh_gharkul: 0,
    new_tech: 0,
    precast: 0,
    logo: 0,

    // IEC
    hoarding: 0,
    banner: 0,
    poster: 0,
    pamphlet: 0,
    brochure: 0,
    bhoomi_poojan: 0,
    gruhpravesh: 0,
  };

  return (
    <section id="main-content">
      <div className="department pb-5 pt-3">
        <div className="container">
          <h1 className="heading py-1">महा आवास अभियान</h1>

          <div className="row g-4">

            {/* ================= LANDLESS ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_1 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>LANDLESS</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            <span>एकुण भूमिहीन लाभार्थी:230111 </span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>आज अखेर जागा उपलब्ध:164702 </span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>उर्वरित भूमिहीन लाभार्थी:65409</span>
                          </h6>
                        </div>

                        {/* duplicate for smooth scroll */}
                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            <span>एकुण भूमिहीन लाभार्थी:230111 </span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>आज अखेर जागा उपलब्ध:164702 </span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>उर्वरित भूमिहीन लाभार्थी: 65409</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1 ">
                      <img className="logoo mb-2" src={Icon1} alt="Landless"  />
                      
                      <Link to="/landless" className="mt-auto">
                        <button className="btn btn-sm btn-outline-primary ">
                          <div>Details
                          </div>
                        </button>
                      </Link> 
                    </div>

                </div>
              </div>
            </div>

            {/* ================= CAPACITY BUILDING ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_2 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>CAPACITY BUILDING</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            <span>एकूण कार्यशाळेची संख्या: {cardCounts.yekun_karyashala_sankhya}</span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>एकूण लाभार्थी मेळावे: {cardCounts.labharthi_melave}</span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>मेळावा उपस्थित लाभार्थी: {cardCounts.prashikshan_purn_zalelya_gavandi_sankya}</span>
                          </h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            <span>एकूण कार्यशाळेची संख्या: {cardCounts.yekun_karyashala_sankhya}</span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>एकूण लाभार्थी मेळावे: {cardCounts.labharthi_melave}</span>
                          </h6>
                          <h6 className="custom-heading">
                            <span>मेळावा उपस्थित लाभार्थी: {cardCounts.prashikshan_purn_zalelya_gavandi_sankya}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1">
                  <img className="logoo mb-2" src={Icon2} alt="Capacity Building"/>
                  
                  <Link to="/CapacityBuilding" className="mt-auto">
                    <button className="btn btn-sm btn-outline-primary">
                      <div>Details  
                      </div>
                    </button>
                  </Link>
                </div>

                </div>
              </div>
            </div>

            {/* ================= CONVERGENCE ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_3 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>CONVERGENCE</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>स्वच्छ भारत अभियान: 1173585</span></h6>
                          <h6 className="custom-heading"><span>राष्ट्रीय ग्रामीण जीवनोन्नती मिशन:232795 </span></h6>
                          <h6 className="custom-heading"><span>उज्ज्वला योजना: 1173585</span></h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>सौभाग्य योजना:1173585 </span></h6>
                          <h6 className="custom-heading"><span>CSR निधी:19650 </span></h6>
                          <h6 className="custom-heading"><span>जलजीवन मिशन: 1173585</span></h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>जिल्हा परिषद सेस:232795 </span></h6>
                          <h6 className="custom-heading"><span>पंचायत समिती सेस:173710 </span></h6>
                          <h6 className="custom-heading"><span>ग्रामपंचायत सेस: 294040</span></h6>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1">
                      <img className="logoo mb-2" src={Icon4} alt="Innovations" />

                      <Link to="/convergence" className="mt-auto">
                        <button className="btn btn-sm btn-outline-primary">
                          <div>Details </div>
                        </button>
                      </Link>
                    </div>


                </div>
              </div>
            </div>

            {/* ================= INNOVATIONS ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_4 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>INNOVATIONS</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>बहुमजली इमारती:2860</span></h6>
                          <h6 className="custom-heading"><span>गृहसंकुले:1626 </span></h6>
                          <h6 className="custom-heading"><span>बहुमजली गृहसंकुले:744 </span></h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>कॉप शॉप:359 </span></h6>
                          <h6 className="custom-heading"><span>डेमो हाऊस तालुका:351</span></h6>
                          <h6 className="custom-heading"><span>सॅण्ड बँक:5454 </span></h6>
                          <h6 className="custom-heading"><span>घरकुल मार्ट:1803 </span></h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1">
                      <img className="logoo mb-2" src={Icon4} alt="Innovations" />

                      <Link to="/innovations" className="mt-auto">
                        <button className="btn btn-sm btn-outline-primary">
                          <div>Details </div>
                        </button>
                      </Link>
                    </div>

                </div>
              </div>
            </div>

            {/* ================= IEC ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_5 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>I.E.C</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>बँकर्स मिटिंग: 144295</span></h6>
                          <h6 className="custom-heading"><span>बॅनर लावण्यात आले: 144295</span></h6>
                          <h6 className="custom-heading"><span>भूमी पूजन कार्यक्रम: 7648106</span></h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>ब्रॉशर वितरीत केले: 14429500</span></h6>
                          <h6 className="custom-heading"><span>गृहप्रवेश कार्यक्रम: 7644374</span></h6>
                          <h6 className="custom-heading"><span>पत्रके वितरित केली: 14429500</span></h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading"><span>पोस्टर लावली: 721475</span></h6>
                          <h6 className="custom-heading"><span>पुरस्कार वितरण कार्यक्रम: 144295</span></h6>
                          <h6 className="custom-heading"><span>महिला दिन कार्यक्रम: 144295</span></h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1">
                    <img className="logoo mb-2" src={Icon5} alt="I.E.C" />

                    <Link to="/iec" className="mt-auto">
                      <button className="btn btn-sm btn-outline-primary">
                        <div>Details </div>
                      </button>
                    </Link>
                  </div>

                </div>
              </div>
            </div>

            {/* ================= PARTNERSHIPS ================= */}
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="squre_6 p-3">
                <div className="row">
                  <div className="col-10">
                    <h3 className="modern-heading"><span>PARTNERSHIPS</span></h3>

                    <div className="scrolling-container">
                      <div className="scrolling-track">
                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            Rotary Club (पालघर): ₹3.50 कोटी
                          </h6>
                          <h6 className="custom-heading">
                            Relfor Foundation (पुणे): ₹1.95 कोटी
                          </h6>
                        </div>

                        <div className="scrolling-content">
                          <h6 className="custom-heading">
                            Relfor Foundation (अहिल्यानगर): ₹22.50 लक्ष
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-2 d-flex align-items-end flex-column bd-highlight mb-1">
        <img className="logoo mb-2" src={Icon6} alt="Partnerships" />

        <Link to="/partnerships" className="mt-auto">
          <button className="btn btn-sm btn-outline-primary">
            <div>Details </div>
          </button>
        </Link>
      </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyCards;
